// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import ConceptCategorizingArray from '../shared/ConceptCategorizingArray';
import EmentorArray from '../shared/EmentorArray';

const PEConceptComprehension = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir, possiblePages } = props;

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Statements"
        instructions="Using the controls below, please add statements for the activity"
      />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => (
          <ConceptCategorizingArray
            inputDir={inputDir}
            materialPages={possiblePages}
            {...{ control, errors }}
          />
        )}
      />

      <NumberedHeading
        number="2"
        title="eMentor Notes"
        instructions="Using the controls below, add any supplemental content to this page"
      />
      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default PEConceptComprehension;
